import { useQuery } from '@tanstack/react-query';
import { fetchDeviceRestrictions } from '../api/deviceRestrictions';
import { SENSITIVE_QUERY_OPTIONS } from './sensitiveQueryOptions';

export const deviceRestrictionsKeys = {
  all: ['deviceRestrictions'] as const,
  detail: (deviceId: string) => [...deviceRestrictionsKeys.all, deviceId] as const,
};

// useDeviceRestrictions loads the rules of one device. The payload contains PINs, so it follows
// the sensitive cache policy.
export function useDeviceRestrictions(deviceId: string) {
  return useQuery({
    queryKey: deviceRestrictionsKeys.detail(deviceId),
    queryFn: () => fetchDeviceRestrictions(deviceId),
    enabled: Boolean(deviceId),
    ...SENSITIVE_QUERY_OPTIONS,
  });
}
